import { createRouter, createWebHistory } from 'vue-router'
import { useAuth, isDevBypassAuth } from '@/composables/useAuth'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      redirect: '/links'
    },
    {
      path: '/links',
      name: 'Links',
      component: () => import('@/views/LinksPage.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/campaigns',
      name: 'Campaigns',
      component: () => import('@/views/CampaignsPage.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/channels',
      name: 'Channels',
      component: () => import('@/views/ChannelsPage.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/analytics',
      name: 'Analytics',
      component: () => import('@/views/AnalyticsPage.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/audit',
      name: 'Audit',
      component: () => import('@/views/AuditPage.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/fields',
      name: 'Fields',
      component: () => import('@/views/FieldsPage.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/api-tokens',
      name: 'ApiTokens',
      component: () => import('@/views/ApiTokensPage.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/views/LoginPage.vue')
    }
  ]
})

router.beforeEach(async (to, _from, next) => {
  const { isAuthenticated, applyDevBypass, needsProfileRefresh, logout } = useAuth()

  if (isDevBypassAuth()) {
    applyDevBypass()
  }

  if (needsProfileRefresh()) {
    logout()
    next(to.name === 'Login' ? undefined : { name: 'Login', query: { reason: 'profile' } })
    return
  }
  
  if (to.meta.requiresAuth && !isAuthenticated.value) {
    next('/login')
  } else if (to.name === 'Login' && isAuthenticated.value) {
    next('/')
  } else {
    next()
  }
})

export default router
